exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ---blue---*/\n/* ---light theme---*/\n/* ---status---*/\n.root {\n  border-radius: 4px;\n  padding: 8px 24px;\n  background-color: #f8f8f8;\n  margin: 8px 0;\n}\n.row {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 8px 0px;\n}\n.rowBorder {\n  border-bottom: 1px solid #38373b1a;\n}\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  color: #38373b;\n  margin: 8px 0px 8px -8px;\n}", ""]);

// exports
